import Color from 'color';

const GRADIENT_COLORS_REGEX =
    /(rgba?|RGBA?)\(\d{1,3},\s*\d{1,3},\s*\d{1,3}\s*(,\s*\d*(?:\.\d+)?)?\)/g;

export const isGradientColor = (color: string) => {
    return color.includes('linear-gradient');
};

export const getGradientColors = (color: string) => {
    const isGradient = isGradientColor(color);

    if (!isGradient) {
        return [color];
    }

    return Array.from(color.matchAll(GRADIENT_COLORS_REGEX)).map((match) => match[0].toLowerCase());
};

export const darkenGradientColor = (color: string, value: number) => {
    const colors = getGradientColors(color);

    let updatedColor: Color | string = color.toLowerCase();

    for (const color of colors) {
        const darkenColor = Color(color).darken(value);
        updatedColor = updatedColor.replace(color, darkenColor.toString());
    }

    return updatedColor;
};
